import styled from 'styled-components';

import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { SkeletonBodyCopy, SkeletonHeadline } from '@xing-com/skeleton';
import {
  cornerRadiusL,
  scale005,
  scale370,
  spaceXS,
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorBorder,
} from '@xing-com/tokens';

const SkeletonCardContainer = styled.div`
  border: ${scale005} solid ${xdlColorBorder};
  border-radius: ${cornerRadiusL};
  display: flex;
  gap: ${spaceXL};
  margin-bottom: ${spaceXL};
  padding: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    gap: ${spaceL};
    margin-bottom: ${spaceL};
  }
`;

const SkeletonRecommendationsHeadline = styled(SkeletonHeadline)`
  margin: ${spaceL} 0 ${spaceXL};
  max-width: ${scale370};
`;

const SkeletonRecruitersRecommendationsHeadline = styled(SkeletonHeadline)`
  margin: ${spaceXL} 0 ${spaceXS};
  max-width: ${scale370};
`;

const SkeletonRecruitersRecommendationsSubline = styled(SkeletonHeadline)`
  margin-bottom: ${spaceXL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;

const SkeletonCardBodyCopy = styled(SkeletonBodyCopy)`
  align-items: center;
  flex: 1;
`;

export const Styled = {
  SkeletonCardContainer,
  SkeletonRecommendationsHeadline,
  SkeletonRecruitersRecommendationsHeadline,
  SkeletonRecruitersRecommendationsSubline,
  SkeletonCardBodyCopy,
};
